import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=d0a0af9c&"
import script from "./produtos.vue?vue&type=script&lang=js&"
export * from "./produtos.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports